import { Span } from './span.js';
import { Tracer } from './tracer.js';
import { SpanOptions } from './span-options.js';
import { Telemetry } from './telemetry.js';
import { createLogger } from '../logger/logger.js';

export function createConsoleTelemetry(): Telemetry {
  const logger = createLogger('telemetry');

  return {
    createTracer(tracerName: string): Tracer {
      return {
        createSpan<T>(
          name: string,
          opts: SpanOptions,
          fn: (span: Span) => T,
        ): T {
          logger.debug(`[${tracerName}] start span ` + name, opts.attributes);
          return fn({
            setAttribute() {},
          });
        },
        async *iterateSpan<T>(
          name: string,
          opts: SpanOptions,
          iterator: () => AsyncGenerator<T>,
        ): AsyncGenerator<T> {
          yield* iterator();
        },
        getContext() {
          return {
            traceId: '',
            spanId: '',
          };
        },
      };
    },
  };
}
